import React from "react";
import PropTypes from "prop-types";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

import BookmarksIcon from "@material-ui/icons/Bookmarks";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { ReactComponent as BhimUpi } from "../../../utils/icons/bhim-upi.svg";

import AdapterLink from "../../AdapterLink";
import PaymentPlan from "../payment-plan/paymentPlan";

const useStyles = makeStyles(({ palette }) => {
  return {
    icon: {
      color: palette.text.secondary
    },
    text: {
      color: palette.text.primary
    },
    chevron: {
      color: palette.text.secondary
    }
  };
});

const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
    navigator.userAgent
  );
};

const defaultPaymentFamilies = [
  {
    path: "savedcard",
    code: "CARD",
    name: "Saved Cards",
    icon: <BookmarksIcon />
  },
  { path: "card", code: "CARD", name: "Card", icon: <CreditCardIcon /> },
  {
    path: "ib",
    code: "NET_BANKING",
    name: "Netbanking",
    icon: <AccountBalanceIcon />
  },
  // refer PZl-1515
  {
    path: "upiqr",
    code: "UPI",
    name: "UPI/QR Code",
    icon: <BhimUpi viewBox="18 0 80 60" fill="#696969" />
  },
  {
    path: "upiqr",
    code: "UPIQR",
    name: "UPI/QR Code",
    icon: <BhimUpi viewBox="18 0 80 60" fill="#696969" />
  },
  {
    path: "wallet",
    code: "WALLET",
    name: "Wallet",
    icon: <AccountBalanceWalletIcon />
  }
  // { path: "emi", name: "EMI", icon: <ScheduleIcon /> }
];

let isPaymentFamilyExist = false;
const PaymentList = ({ match, charge, isVpos }) => {
  defaultPaymentFamilies.forEach(obj => {
    Object.entries(obj).forEach(([key, value]) => {
      if (`${key}` !== undefined && `${value}`.includes("UpiIntent")) {
        isPaymentFamilyExist = true;
      }
    });
  });

  if (isMobileDevice() && !isPaymentFamilyExist) {
    defaultPaymentFamilies.push({
      path: "UpiIntent",
      code: "UPI",
      name: "Pay via any UPI app",
      icon: <BhimUpi viewBox="18 0 80 60" fill="#696969" />
    });
  }

  const classes = useStyles();
  const { schedule, status, currency } = charge;
  const displaySchedule = schedule && isVpos;

  // if charge is in running state we will not display payment card options
  const displayPaymentList = status === "RUNNING";

  const { customerSavedCards, customerId, paymentFamilies } = charge;
  let paymentToDisplay = defaultPaymentFamilies;
  const shouldHideSavedCards =
    !customerId || !customerSavedCards || customerSavedCards.length === 0;

  if (shouldHideSavedCards) {
    paymentToDisplay = defaultPaymentFamilies.filter(
      f => f.path !== "savedcard"
    );
  }
  // condition for setting vpos payment list - Vpos only support card and save Card
  if (isVpos) {
    const paymentToDisplayVpos = defaultPaymentFamilies.filter(
      f => f.path === "card" || f.path === "savedcard"
    );
    if (shouldHideSavedCards) {
      paymentToDisplay = paymentToDisplayVpos.filter(
        f => f.path !== "savedcard"
      );
    } else {
      paymentToDisplay = paymentToDisplayVpos;
    }

    // condition for running charge status
    if (displayPaymentList) {
      paymentToDisplay = [];
    }
  }
  return (
    <>
      {displaySchedule && (
        <PaymentPlan schedule={schedule} currency={currency} />
      )}
      <List component="nav">
        {paymentToDisplay
          .filter(
            paymentFamily =>
              paymentFamilies.families.indexOf(paymentFamily.code) !== -1
          )
          .map(paymentFamily => {
            return (
              <ListItem
                button
                key={paymentFamily.name}
                id={paymentFamily.path}
                component={AdapterLink}
                to={`${match.url}/${paymentFamily.path}`}
              >
                <ListItemIcon className={classes.icon}>
                  {paymentFamily.icon}
                </ListItemIcon>
                <ListItemText
                  className={classes.text}
                  primary={paymentFamily.name}
                  // secondary={
                  //   <Typography style={{ fontSize: "12px", color: "grey" }}>
                  //     {paymentFamily.code === "UPI"
                  //       ? "BHIM, Google Pay, PhonePe..."
                  //       : ""}
                  //     {paymentFamily.code === "UPIQR"
                  //       ? "GooglePay, PhonePe..."
                  //       : ""}
                  //   </Typography>
                  // }
                />
                <ChevronRightIcon className={classes.chevron} />
              </ListItem>
            );
          })}
      </List>
    </>
  );
};

PaymentList.propTypes = {
  match: PropTypes.shape().isRequired,
  isVpos: PropTypes.bool,
  charge: PropTypes.shape({
    customerSavedCards: PropTypes.arrayOf(PropTypes.shape()),
    customerId: PropTypes.string,
    paymentFamilies: PropTypes.shape().isRequired,
    schedule: PropTypes.objectOf(PropTypes.any),
    currency: PropTypes.string.isRequired,
    status: PropTypes.string
  }).isRequired
};

PaymentList.defaultProps = {
  isVpos: false
};

export default PaymentList;
